import React from 'react'

import Tile from './tile'
import Figure from './figure'

import './currentSample.css'

const CurrentSample = ({ tile, colors }) => {
	return (
		<div id='current-sample'>
			<Tile 
				onSelectTile={()=>{}}
				width='320'
				height='320'
				>
			{tile.paths.map(( path, index ) => {
				return <Figure key={index} transform={path.transform} d={path.d} fill={colors[index]}/>
			})}
			</Tile>
		</div>
	)
}

export default CurrentSample;


// WEBPACK FOOTER //
// ./src/components/mosaic/currentSample.jsx